import sheetShareModal from "@/views/share/shareModal.vue";

export default {
    components: {
        sheetShareModal
    },
    props: {},
    data () {
        return {
            showShareModal: false,

            dshRenderName: undefined
        };
    },
    computed: {
        dshRender () {
            return this[this.dshRenderName];
        }
    },
    methods: {
        /* ------ 分享相关 --------- */
        // 点击分享
        clickShare () {
            this.openShareModal();
        },
        // 打开分享模态框
        openShareModal () {
            this.dshRenderName = "sheetShareModalRender";
            this.showShareModal = true;
        },
        // 关闭分享模态框
        closeShareModal () {
            this.dshRenderName = undefined;
            this.showShareModal = false;
        },
        // 切换分享模态框
        toggleShareModal (bool) {
            this.showShareModal = bool;
        },

        // 分享模态框渲染函数
        sheetShareModalRender (h, params) {
            return this.showShareModal
                ? h("sheet-share-modal", {
                    props: {
                        value: this.showShareModal,
                        companyId: this.companyId,
                        appId: this.appId,
                        refKey: this.modKey,
                        screenKey: this.screenKey,
                        dataId: this.dataId,
                        canEdit: this.canEdit,
                        isCreate: this.isCreate
                    },
                    on: {
                        input: this.toggleShareModal
                    }
                })
                : undefined;
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/sheet/operation/shareBtnMixin.js